import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import CN from 'classnames';
import { Carousel } from '@sbt-web/carousel';
import { useIsVisible, useViewport } from '@sbt-web/hooks';
import { AdItem } from '@sbt-web/network/types';
import { RecommenderGridView } from '@/client/components/Shared/RecommenderGridView';
import { Card } from './Card';
import cssClass from './index.module.scss';
interface Props {
  data: AdItem[];
  onClick?: (item: AdItem, index: number) => void;
  onCardImpression?: (item: AdItem, index: number) => void;
  onVisible?: () => void;
  className?: string;
  title: string;
  ariaLabel?: string;
  navigationLabels: {
    left: string;
    right: string;
  };
  isLoading?: boolean;
}
const observerOptions = {
  threshold: 0.1
};
export function AdDetailCarousel(t0) {
  const $ = _c(37);
  const {
    data,
    onClick,
    onCardImpression,
    onVisible,
    className: t1,
    title,
    ariaLabel,
    navigationLabels,
    isLoading
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const {
    isDesktop
  } = useViewport();
  const ref = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      observerOptions
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const [isVisible, setElement, unobserve] = useIsVisible(t2);
  let t3;
  if ($[1] !== data.length || $[2] !== setElement) {
    t3 = () => {
      if (data.length > 0 && ref.current) {
        setElement(ref.current);
      }
    };
    $[1] = data.length;
    $[2] = setElement;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== data || $[5] !== setElement) {
    t4 = [setElement, data];
    $[4] = data;
    $[5] = setElement;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[7] !== isVisible || $[8] !== onVisible || $[9] !== unobserve) {
    t5 = () => {
      if (isVisible) {
        onVisible?.();
        unobserve();
      }
    };
    t6 = [onVisible, isVisible, unobserve];
    $[7] = isVisible;
    $[8] = onVisible;
    $[9] = unobserve;
    $[10] = t5;
    $[11] = t6;
  } else {
    t5 = $[10];
    t6 = $[11];
  }
  useEffect(t5, t6);
  if (!isDesktop) {
    let t7;
    if ($[12] !== data || $[13] !== isLoading || $[14] !== onCardImpression || $[15] !== onClick || $[16] !== onVisible || $[17] !== title) {
      t7 = <RecommenderGridView title={title} titleClass="headline-5" items={data} onCardImpression={onCardImpression} onClick={onClick} onImpression={onVisible} isLoading={isLoading} />;
      $[12] = data;
      $[13] = isLoading;
      $[14] = onCardImpression;
      $[15] = onClick;
      $[16] = onVisible;
      $[17] = title;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    let t8;
    if ($[19] !== className || $[20] !== t7) {
      t8 = <div className={className}>{t7}</div>;
      $[19] = className;
      $[20] = t7;
      $[21] = t8;
    } else {
      t8 = $[21];
    }
    return t8;
  }
  let t7;
  if ($[22] !== data || $[23] !== onCardImpression || $[24] !== onClick) {
    let t8;
    if ($[26] !== onCardImpression || $[27] !== onClick) {
      t8 = (item, index) => <li key={item.urn}><Card item={item} onClick={() => onClick?.(item, index)} onImpression={() => onCardImpression?.(item, index)} /></li>;
      $[26] = onCardImpression;
      $[27] = onClick;
      $[28] = t8;
    } else {
      t8 = $[28];
    }
    t7 = data.map(t8);
    $[22] = data;
    $[23] = onCardImpression;
    $[24] = onClick;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  const cards = t7;
  let t8;
  if ($[29] !== ariaLabel || $[30] !== cards || $[31] !== className || $[32] !== data.length || $[33] !== isDesktop || $[34] !== navigationLabels || $[35] !== title) {
    t8 = data.length > 0 ? <div ref={ref} className={CN(cssClass["carousel-section"], className)} aria-label={ariaLabel ?? title}><h3 className={`headline-5 ${cssClass["carousel-section__title"]}`}>{title}</h3><Carousel labelArrows={navigationLabels} showButtons={isDesktop} cssClass={CN(cssClass.carousel, "slider-nav-round", "slider-nav-page")} listItems={cards} currentIndex={0} /></div> : null;
    $[29] = ariaLabel;
    $[30] = cards;
    $[31] = className;
    $[32] = data.length;
    $[33] = isDesktop;
    $[34] = navigationLabels;
    $[35] = title;
    $[36] = t8;
  } else {
    t8 = $[36];
  }
  return t8;
}